import { render } from "./LabContainer.vue?vue&type=template&id=36c6f2ad&scoped=true"
import script from "./LabContainer.vue?vue&type=script&lang=js"
export * from "./LabContainer.vue?vue&type=script&lang=js"

import "./LabContainer.vue?vue&type=style&index=0&id=36c6f2ad&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c6f2ad"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner});
